import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaSpinner, FaExclamationTriangle } from 'react-icons/fa';
import { guestApi } from '../../api/guestList';
import { pledgeApi } from '../../api/pledges';
import { toast } from 'react-toastify';
import { useAuthContext } from '../../context/AuthContext';

const DeleteGuestModal = ({ show, onHide, guest, onGuestDeleted }) => {
  const { isAuthenticated } = useAuthContext();

  const [submitting, setSubmitting] = useState(false);

  const handleDeleteGuest = async () => {
    if (!guest) return;

    setSubmitting(true);
    try {
      if (guest.pledge_id) {
        await pledgeApi.deletePledge(guest.pledge_id);
      }
      
      await guestApi.deleteGuest(guest.id);

      toast.success('âœ… Guest deleted successfully!');
      onGuestDeleted();
      onHide();

    } catch (err) {
      console.error('Error deleting guest:', err);
      if (err.response?.status === 404 && guest) {
        toast.success('âœ… Guest deleted successfully!');
        onGuestDeleted();
        onHide();
      } else {
        toast.error(err.response?.data?.message || err.message || 'Failed to delete guest');
      }
    } finally {
      setSubmitting(false);
    }
  };

  
  if (!isAuthenticated) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0">
      </Modal.Header>
      <Modal.Body className="text-center pb-5">
        <FaExclamationTriangle className="text-warning mb-3" size={48} />
        <h4>Futa Mgeni</h4>
        <p>Una uhakika unataka kufuta mgeni huyu <b>{guest?.jina}</b>?</p>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button variant="secondary" onClick={onHide} className="px-4">
            Hapana, Ghairi
          </Button>
          <Button variant="danger" onClick={handleDeleteGuest} disabled={submitting} className="px-4">
            {submitting ? <FaSpinner className="fa-spin" /> : 'Ndiyo, Futa'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteGuestModal;
